import type { TableColumn } from '@library/types/utils';
import type { UserColumns } from '@library/types/user';

export const USER_ROLES_HEADER: Array<TableColumn<UserColumns>> = [
  {
    column: 'email',
    essential: true,
    label: 'Users',
    sortEnabled: true
  },
  {
    column: 'role_name',
    essential: true,
    label: 'Role',
    sortEnabled: false
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created On',
    sortEnabled: true,
    width: 'w-1/5'
  },
  {
    column: 'deactivated',
    essential: true,
    label: 'Status',
    sortEnabled: true,
    width: 'w-1/5'
  }
];
